const leftMenu = {
	vds: {
		title: 'menu/vds',
		link: '/vds/list',
		tabs: {
			'vds': 'menu/vds',
			'disks': 'service/extdisks',
			'backups': 'service/backups',
			'sshkey': 'sshkey/title',
			'iso': 'service/iso',
			'additional-services': 'service/additional'
		}
	},
	/*
	certificate: {
		title: 'menu/certificate_ssl',
		link: '/certificate/list',
		tabs: {
			'certificate': 'menu/certificate_ssl'
		}
	},
	*/
	domains: {
		title: 'menu/domains_and_dns',
		link: '/domains/list',
		tabs: {
			'domains': 'main/domains',
			'dns': 'menu/dns',
			'person': 'menu/persons'
		}
	},
	account: {
		title: 'menu/clients',
		link: '/account/list',
		tabs: {
			'account': 'account/title',
			'user': 'user/title',
			'notes': 'notes/title'
		}
	},
	operation: {
		title: 'menu/finance',
		link: '/operation/list',
		tabs: {
			'operation': 'operation/title',
			'paymentsaved': 'paymentsaved/title',
			'paymentauto': 'paymentauto/title',
			'document': 'document/title',
			'payer': 'payer/title'
		}
	},
	request: {
		title: 'request/title',
		link: '/request/list',
		tabs: {
			'request': 'request/title'
		}
	},
	partner: {
		title: 'menu/partprog',
		link: '/partner/list',
		tabs: {
			'partner': 'partner/title',
			'partnerprogram': 'partnerprogram/title',
			'partneractions': 'partneractions/title'
		}
	},
	bonus: {
		title: 'bonus/title',
		link: '/bonus/list',
		tabs: {
			'bonus': 'bonus/title'
		}
	},
	ticket: {
		title: 'ticket/tickets',
		link: '/ticket/list',
		tabs: {
			'ticket': 'main/list_all'
		}
	},
	logs: {
		title: 'logs/title',
		link: '/logs/list',
		tabs: {
			'logs': 'logs/title'
		}
	},
	chart: {
		title: 'menu/charts',
		link: '/chart/list',
		tabs: {
			'chart': 'chart/title'
		}
	},
	template: {
		title: 'menu/settings',
		link: '/template/list',
		tabs: {
			'template': 'template/title',
			'server': 'server/title',
			'ippool': 'ippool/title',
			'text': 'text/title',
			'admin': 'admin/title',
			'role': 'role/title',
			'payment': 'payment/title',
			'servergroup': 'servergroup/title',
			'plangroup': 'plangroup/title',
			'templategroup': 'templategroup/title',
			'servicetype': 'servicetype/title',
			'plan': 'plan/title',
			'planarchive': 'plan/archive_title',
			'department': 'department/title',
			'ticketrule': 'ticketrule/title',
			'zone': 'zone/title'
		}
	},
	datacenter: {
		title: 'menu/equipment',
		link: '/datacenter/list',
		tabs: {
			'datacenter': 'datacenter/title',
			'rack': 'rack/title',
			'rackdevice': 'rackdevice/title',
			'rackspare': 'rackspare/title',
			'rackservice': 'rackservice/title'
		}
	}
}
///////////////////////////////////////////////////////////////////////////////
export default leftMenu
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/store/admin-left-menu-vdsina.js